var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipboardConfigureFields(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.5 43.79H99.5699V83.33H147.5V43.79Z",
    fill: "#E9AF34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.5 43.79H99.5699V83.33H147.5V43.79Z",
    stroke: "#E9AF34",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.21 31.52H3.67C3.02383 31.52 2.5 32.0438 2.5 32.69V131C2.5 131.646 3.02383 132.17 3.67 132.17H85.21C85.8562 132.17 86.38 131.646 86.38 131V32.69C86.38 32.0438 85.8562 31.52 85.21 31.52Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4 28.18V42.74H20.47V28.18H34.85C34.8085 26.8953 35.0257 25.6153 35.4887 24.4161C35.9517 23.2169 36.6511 22.1231 37.5452 21.1996C38.4394 20.2761 39.51 19.5418 40.6936 19.0403C41.8772 18.5388 43.1495 18.2804 44.435 18.2804C45.7204 18.2804 46.9927 18.5388 48.1763 19.0403C49.3599 19.5418 50.4306 20.2761 51.3247 21.1996C52.2189 22.1231 52.9182 23.2169 53.3813 24.4161C53.8443 25.6153 54.0615 26.8953 54.02 28.18H68.4Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4 54.4601H20.47V90.4101H68.4V54.4601Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.38 58.88V38.35C80.3886 38.0707 80.2897 37.7988 80.1036 37.5903C79.9175 37.3819 79.6585 37.2529 79.38 37.23H72.38",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.06 37.23H9.55005C9.40689 37.2339 9.2659 37.2659 9.13514 37.3243C9.00438 37.3827 8.88641 37.4663 8.78796 37.5703C8.68952 37.6743 8.61254 37.7967 8.56143 37.9305C8.51031 38.0643 8.48605 38.2068 8.49005 38.35V124.79C8.48606 124.933 8.51039 125.075 8.56163 125.208C8.61286 125.341 8.69 125.463 8.78856 125.566C8.88713 125.669 9.00518 125.752 9.13588 125.809C9.26658 125.867 9.40735 125.897 9.55005 125.9L70.8001 126.46L80.38 116.87V70.36",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8 126.46V116.87H80.39",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.47 107.18H68.4",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.47 101.19H68.4",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.47 113.17H56.42",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.99 54.65H142.72",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.99 60H142.72",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.99 69.36H142.72",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.99 74.7101H133.35",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.96 58.66V61.34H106.59V51.97H113.28",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.97 56L111.28 59.31L118.59 52",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.97 68.02H106.6V77.39H115.97V68.02Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.45 106.24H139.11V108.91",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.11 113.64V149.13",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4.73 4.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5699 146.77V111.27",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4.73 4.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5699 108.91V106.24H102.24",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.12 106.24H134",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4.89 4.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.04 116.73L119.34 118.75L116.65 116.73",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.65 131.55L119.34 129.53L122.04 131.55",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.27 118.1L114.67 121.44L111.58 122.77",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.41 130.18L124.01 126.83L127.11 125.51",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.34 133.23V115.04",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.22 128.69L111.47 119.59",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.22 119.59L111.47 128.69",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.58 125.51L114.67 126.83L114.27 130.18",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.11 122.77L124.01 121.44L124.41 118.1",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.22 139.76H131.47",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.22 144.55H119.34",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.44 32.37C46.7541 32.37 48.63 30.4941 48.63 28.18C48.63 25.8659 46.7541 23.99 44.44 23.99C42.1259 23.99 40.25 25.8659 40.25 28.18C40.25 30.4941 42.1259 32.37 44.44 32.37Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.41 37.23H26.46",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.47 32.8V28.18H34.85C34.8085 26.8953 35.0257 25.6153 35.4887 24.4161C35.9517 23.2169 36.6511 22.1231 37.5452 21.1996C38.4394 20.2761 39.51 19.5418 40.6936 19.0403C41.8772 18.5388 43.1495 18.2804 44.435 18.2804C45.7204 18.2804 46.9927 18.5388 48.1763 19.0403C49.3599 19.5418 50.4306 20.2761 51.3247 21.1996C52.2189 22.1231 52.9182 23.2169 53.3813 24.4161C53.8443 25.6153 54.0615 26.8953 54.02 28.18H68.4V32.8",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93 61.9101C77.28 55.9101 75.78 74.3501 60.3 75.6101",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.44 71.78L54.89 75.39L61.29 79.26L61.44 71.78Z",
    fill: "#1F323D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H150V150H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardConfigureFields);
export default __webpack_public_path__ + "static/media/clipboard_configure_fields.49744bdc8e0d3f32bd0023ee9339905d.svg";
export { ForwardRef as ReactComponent };